import { render, staticRenderFns } from "./AuthSqaComponent.vue?vue&type=template&id=016af355&scoped=true"
import script from "./AuthSqaComponent.vue?vue&type=script&lang=js"
export * from "./AuthSqaComponent.vue?vue&type=script&lang=js"
import style0 from "./AuthSqaComponent.vue?vue&type=style&index=0&id=016af355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016af355",
  null
  
)

export default component.exports